import type { InjectionKey, Ref } from 'vue';

export type IdRef = Readonly<{
    id: string;
    tabid: string;
    btnid: string;
}>;

export type TabPaneProps = Readonly<{
    title?: string;
}>;

export type TabPaneType = {
    idRef: IdRef;
    active: Ref<boolean | undefined>;
    props: TabPaneProps;
    hidden: Ref<boolean | undefined>;
    element: HTMLElement;
};

export type TabButtonProps = Readonly<{
    active?: boolean;
    hidden?: boolean;
    title?: string;
    idRef: IdRef;
}>;

export const NavTabsParentKey = Symbol('NavTabsParent') as InjectionKey<NavTabsParent>;
export interface NavTabsParent {
    registerPane?: (pane: TabPaneType) => void;
    updatePane?: (idRef: IdRef, element: HTMLElement) => void;
    unregisterPane?: (idRef: IdRef) => void;
}

export type TabButtonType = {
    idRef: IdRef;
    active: Ref<boolean | undefined>;
};

export const NavTabsSimpleParentKey = Symbol('NavTabsSimpleParentKey') as InjectionKey<NavTabsSimpleParent>;
export interface NavTabsSimpleParent {
    registerButton?: (button: TabButtonType) => void;
    unregisterButton?: (idRef: IdRef) => void;
    activateButton?: (idRef: IdRef) => void;
}
